import { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { actions as cmsActions } from 'modules/cms/actions'

// Components
import { Shelf } from '@tracklib/kit'
import ArticleItem from 'components/articles/item'

// Types
import { CmsPage, State, Dispatch } from 'types'

type ArticlesBlockProps = {
  value: {
    heading: string
    override_margin_bottom: number
    articles: Array<{
      article: number
      image: string
      title: string
      owner: string
    }>
  }
  // mapStateToProps
  articleIds: Array<number>
  articleList: Array<CmsPage>
  // mapDispatchToProps
  fetchArticlesByIds: (articleIds: Array<number>) => void
}

class ArticlesBlock extends Component<ArticlesBlockProps> {
  componentDidMount() {
    const { articleIds, fetchArticlesByIds } = this.props
    fetchArticlesByIds(articleIds)
  }

  render() {
    const {
      value: { heading, override_margin_bottom },
      articleList,
    } = this.props
    return (
      <Shelf heading={heading} marginBottom={override_margin_bottom}>
        {articleList
          .filter((i, index) => index < 3)
          .map(article => {
            const cmsArticle = this.props.value.articles && this.props.value.articles.find(x => x.article === article.id)
            return (
              <Shelf.Item key={article.id}>
                <ArticleItem
                  key={article.id}
                  article={article}
                  title={cmsArticle?.title}
                  owner={cmsArticle?.owner}
                  image={cmsArticle?.image}
                />
              </Shelf.Item>
            )
          })}
      </Shelf>
    )
  }
}

const mapStateToProps = (state: State, { value: { articles } }: ArticlesBlockProps): JSX.Element => {
  const allArticles = state.entities.pages
  const articleIds = articles.map(x => x.article)
  return {
    articleList: Object.keys(allArticles)
      .map(id => allArticles[id])
      .filter(article => articleIds.includes(article.id)),
    articleIds,
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchArticlesByIds: (articleIds: Array<number>) => dispatch(cmsActions.fetchArticlesByIds(articleIds)),
})
export default connect(mapStateToProps, mapDispatchToProps)(ArticlesBlock)
